import { useState } from "react";
import { Link } from "react-router-dom";
import { api, ApiError } from "../lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    setErrorMsg("");
    try {
      await api.post("/api/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      if (err instanceof ApiError && err.status === 400) {
        setErrorMsg("Please enter a valid email.");
      } else {
        setErrorMsg(
          err instanceof Error ? err.message : "Something went wrong."
        );
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-50 px-6">
      <div className="w-full max-w-sm">
        <Link
          to="/"
          className="mb-8 block text-center text-lg font-semibold text-ink-900 no-underline"
        >
          BrandEcho
        </Link>
        <div className="card">
          <h1 className="text-xl font-semibold text-ink-900">
            Forgot your password?
          </h1>
          <p className="mt-1 text-sm text-ink-500">
            Enter your email and we'll send you a reset link. The link expires
            in 30 minutes.
          </p>
          {done ? (
            <div className="mt-6 space-y-4">
              <div className="rounded-lg border border-emerald-200/70 bg-emerald-50/60 px-3.5 py-3 text-sm text-emerald-900">
                If an account exists for <strong>{email}</strong>, we've sent a
                reset link. Check your inbox (and spam folder).
              </div>
              <Link to="/login" className="btn-secondary w-full no-underline">
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-ink-700">
                  Email
                </label>
                <input
                  className="input"
                  type="email"
                  required
                  autoFocus
                  placeholder="you@domain.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="btn-primary w-full"
                disabled={busy}
              >
                {busy ? "Sending…" : "Send reset link"}
              </button>
              {errorMsg ? (
                <p className="text-sm text-red-600">{errorMsg}</p>
              ) : null}
              <Link
                to="/login"
                className="block text-center text-sm text-ink-600 no-underline hover:text-ink-900 hover:underline"
              >
                Back to sign in
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
